<template>
  <div v-show="isShowVideo" class="video-player">
    <div class="video-wrap">
      <div class="video-con">
        <video
          id="curvideo"
          ref="video"
          :src="videoSrc"
          preload
          width="100%"
          playsinline=""
          x5-playsinline=""
          controls
          controlslist="nodownload noremoteplayback"
          disablepictureinpicture=""
        ></video>
        <div v-if="showTitle" class="infor">
          <p class="name">{{ videoInfo && videoInfo.title }}</p>
        </div>
        <div class="close-btn" @click="closeVideoPlayer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "VideoPlayer",
  props: {
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["isShowVideo", "videoSrc", "videoInfo"])
  },
  watch: {
    videoSrc() {
      if (this.isShowVideo && this.videoSrc) {
        this.$nextTick(this.playVideo);
      }
    }
  },
  methods: {
    ...mapActions(["changeShowVideo", "changeIsPlayBgm"]),
    closeVideoPlayer() {
      this.changeShowVideo({ isShow: false, src: "" });
      this.$refs.video.pause();
    },
    playVideo() {
      this.$refs.video.disablePictureInPicture = true;
      this.$refs.video.play();
      this.changeIsPlayBgm(false);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: rgba(8, 8, 11, 0.7);
  .video-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .video-con {
    position: absolute;
    top: 40%;
    left: 48%;
    .mixin_com(width, 1000);
    .mixin_com(height, 495);
    .mixin_com(margin-top, -247);
    .mixin_com(margin-left, -440);
    video {
      display: block;
      .mixin_com(width, 880);
      .mixin_com(height, 495);
    }
  }
  .close-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
    cursor: pointer;
    background: url("~@/assets/images/btn-close.png") no-repeat center;
    background-size: contain;
    transition: all 0.5s 0s;
    .mixin_com(width, 33);
    .mixin_com(height, 33);
    .mixin_com(margin-top, -247);
    .mixin_com(margin-left, 408);
    &:hover {
      .transform(rotate(180deg));
    }
  }
  .infor {
    position: absolute;
    bottom: 0;
    .mixin_com(left, 890);
    .mixin_com(width, 140);
    .mixin_com(font-size, 16);

    color: #fff;
    .name {
      .mixin_com(font-size, 20);
      .mixin_com(padding-bottom, 5);
      .mixin_com(margin-bottom, 5);

      border-bottom: 1px solid #c0a04d;
    }
  }
}

@media screen and (max-width: 1440px) {
  .video-player {
    zoom: 0.8;
  }
}
</style>
